import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { styleUtils } from '../../../../shared/utils';
import styles from './styles';
import { Br, Text } from "../../../../shared/components/Text";
import Section from "../../../../shared/components/Section";
import {Col, Row, View} from "../../../../shared/components/View";
import {COLORS} from "../../../../shared/design/tokens";
import { ConfirmationIcon } from "../../../../assets/icons";
import { Trans } from "react-i18next";
import {Link, useHistory} from "react-router-dom";
import { ROUTES } from '../../../../shared/constants/navigation';
import {Button} from "../../../../shared/components";

const { style } = styleUtils;
const Container = style('div', styles.container);
const Title = style(Text, styles.title);
const Content = style(View, styles.content);
const IconContainer = style(Col, styles.iconContainer);

const textProps = {
  size: "normal",
  className: "text",
  color: COLORS.TEXT.BLACK,
  weight: 400
};

const InstancesConfirmation = (props) => {
  const { clearForm } = props;
  const [formCleared, setFormCleared] = useState(false);

  useEffect(() => {
    if(!formCleared) {
      clearForm();
      setFormCleared(true);
    }
  }, [clearForm, formCleared]);

    let {t} = props;
    const history = useHistory();
    return (
      <Container>
        <Section width="100%">
          <Content>
            <Row>
              <Col>
                <Title size="xlarge">{t('title')}</Title>
              </Col>
            </Row>
            <Row gutter={50}>
              <Col span={16}>
                <Text {...textProps}>
                  {t('confirmationText')}
                  <Br />
                  <Br />
                  <Trans
                    t={t}
                    i18nKey="orderDetails"
                    values={{
                      orderId: 1209,
                      orderDays: 3
                    }}
                    components={[
                      <Text {...textProps} weight={700}/>,
                      <Text {...textProps} weight={700}/>
                    ]}
                  />
                </Text>
                <Text {...textProps}>
                  <Br/>
                  <Br/>
                  <Trans
                    t={t}
                    i18nKey="contactText"
                    components={[
                      <Link to={ROUTES.SIGN_UP_CONTACT}/>,
                    ]}
                  />
                </Text>
              </Col>
              <IconContainer span={8}>
                <ConfirmationIcon widh={266} height={254} fill={COLORS.ICON.SEA_BLUE}/>
              </IconContainer>
            </Row>
            <Row gutter={20} style={{marginTop: '20px'}}>
              <Col span={6}><Button colored="seablue" fluid onClick={() => window.location.pathname = "/"}>{t('goToHome')}</Button></Col>
              <Col span={6}><Button fluid onClick={() => history.push(ROUTES.ROOT)}>{t('newOrder')}</Button></Col>
            </Row>
          </Content>
        </Section>
      </Container>
    );
}

InstancesConfirmation.propTypes = {
  handlePreviousStepClick: PropTypes.func,
  handleNextStepClick: PropTypes.func,
};

export default InstancesConfirmation;
